import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Typography, MuiBox, SvgIcon, color } from '@kis-technologies/kis-ui';
import { useActions } from 'hooks/useActions';
import { actions as kiosksActions, selectors as kiosksSelectors } from 'store/kiosks';
import StatusOverlay from './StatusOverlay';
import { useStyles } from '../styled';
import { KioskStatusProps } from '../types';

const KioskStatus = (props: KioskStatusProps) => {
  const { kiosk } = props;

  const { getKiosk } = useActions({ getKiosk: kiosksActions.getKiosk });

  const { pending: kioskPending } = useSelector(kiosksSelectors.selectAction);

  const [showStatusOverlay, setShowStatusOverlay] = useState<boolean>(false);

  const classes = useStyles({ showOverlay: showStatusOverlay })();

  const onStatusClick = () => {
    getKiosk({ kioskId: kiosk.id });
    if (!kioskPending) setShowStatusOverlay(true);
  };

  const onClose = () => {
    setShowStatusOverlay(false);
  };

  return (
    <>
      <div className={classes.kioskStatusRow}>
        {kiosk.online ? (
          <Button
            onClick={onStatusClick}
            className={kiosk.status === 'Active' ? classes.activeStatusButton : classes.inactiveStatusButton}
          >
            <SvgIcon name="circle" size={15} style={{ width: '30px' }} />
            {kiosk.status}
          </Button>
        ) : (
          <MuiBox className={classes.offlineStatusBox}>
            <SvgIcon name="circle" size={15} style={{ width: '30px' }} color={color.RED} />
            <Typography fontSize={16} fontWeight={600} color={color.RED}>
              Offline
            </Typography>
          </MuiBox>
        )}
      </div>

      {/* STATUS OVERLAY */}
      {showStatusOverlay && <StatusOverlay onClose={onClose} isOpen={showStatusOverlay} kiosk={kiosk} />}
    </>
  );
};

export default KioskStatus;
